import { render } from "./DarkModeToggle.vue?vue&type=template&id=2dc7c8b7&scoped=true"
import script from "./DarkModeToggle.vue?vue&type=script&lang=js"
export * from "./DarkModeToggle.vue?vue&type=script&lang=js"

import "./DarkModeToggle.vue?vue&type=style&index=0&id=2dc7c8b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc7c8b7"]])

export default __exports__